// Layer 3 — regular agent schedules — docs/real-estate/be/
// 10-api-reference.md §A8. `working_hours` and `agent_ids` are optional on
// create; each can also be set later with its own PUT. Deleting a schedule
// (204) also removes its hours, overrides and agent links — agents left
// without a schedule fall back to the project's Layer-0 hours.
import { request } from './http';

export function listSchedules(pid) {
  return request({ path: `/properties/${pid}/schedules` });
}

// `body`: { name, working_hours?, agent_ids? }.
export function createSchedule(pid, body) {
  return request({
    method: 'post',
    path: `/properties/${pid}/schedules`,
    data: body,
  });
}

// Used by the agent calendar (§A11) to load the full schedule (working
// hours + agents) before opening ScheduleModal in edit mode — the
// calendar's day entries only carry that one day's resolved slots.
export function getSchedule(scheduleId) {
  return request({ path: `/properties/schedules/${scheduleId}` });
}

// Only `name` is accepted here (schema is additionalProperties:false) —
// working hours and agents each have their own PUT below.
export function patchSchedule(scheduleId, name) {
  return request({
    method: 'patch',
    path: `/properties/schedules/${scheduleId}`,
    data: { name },
  });
}

export function deleteSchedule(scheduleId) {
  return request({
    method: 'delete',
    path: `/properties/schedules/${scheduleId}`,
  });
}

// `workingHours`: [{ day_of_week, start_time, end_time }, ...] — replaces
// the whole grid, same shape as operatingHours.js's setOperatingHours.
export function setScheduleHours(scheduleId, workingHours) {
  return request({
    method: 'put',
    path: `/properties/schedules/${scheduleId}/working-hours`,
    data: { working_hours: workingHours },
  });
}

export function setScheduleAgents(scheduleId, agentIds) {
  return request({
    method: 'put',
    path: `/properties/schedules/${scheduleId}/agents`,
    data: { agent_ids: agentIds },
  });
}

// Schedule-level date overrides — same body/rules as the Layer-0 overrides
// (operatingHours.js), but both times `null` means the scheduled agents
// are off that day rather than "closed".
export function listScheduleOverrides(scheduleId) {
  return request({ path: `/properties/schedules/${scheduleId}/overrides` });
}

export function createScheduleOverride(scheduleId, body) {
  return request({
    method: 'post',
    path: `/properties/schedules/${scheduleId}/overrides`,
    data: body,
  });
}

export function deleteScheduleOverride(scheduleId, overrideId) {
  return request({
    method: 'delete',
    path: `/properties/schedules/${scheduleId}/overrides/${overrideId}`,
  });
}
